import { render, staticRenderFns } from "./kioskManagement.vue?vue&type=template&id=71972e1e"
import script from "./kioskManagement.vue?vue&type=script&lang=js"
export * from "./kioskManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports